import * as React from "react";
import useConfig from "../hooks/useConfig";
import { SecureForm } from "../types";

interface Props {
  secureForm: SecureForm;
  agentDisplayName: string;
}

export default function SecureFormDisplay(props: Props) {
  if (!props.secureForm || props.secureForm.State !== "Waiting") {
    return null;
  }

  const configContext = useConfig();

  function renderMessageText() {
    let text = configContext.SecureFormRequestText.replace(
      "@AgentName",
      props.agentDisplayName
    );
    return text;
  }

  function onClick(e: any) {
    e.preventDefault();
    window.open(
      props.secureForm.FormUrl,
      "_blank",
      `toolbar=no,
                                    location=no,
                                    status=no,
                                    menubar=no,
                                    scrollbars=yes,
                                    resizable=yes,
                                    width=300,
                                    height=400`
    );
  }

  return (
    <div className="velaro-secure-form">
      <a href={props.secureForm.FormUrl} onClick={onClick}>
        {renderMessageText()}
      </a>
    </div>
  );
}
